import { HUB_HOSTED_DOMAINS } from '@/config/appConfig';

/**
 * Firebase Auth `authDomain` for this page load.
 *
 * On an address Firebase Hosting serves the Hub on, sign-in runs on that same address,
 * so the redirect sign-in never crosses sites (Safari / iPhone block that). Anywhere
 * else — localhost, the emulator — the build-time `VITE_FIREBASE_AUTH_DOMAIN` is used
 * unchanged.
 */
export function pickAuthDomain(hostname: string, fallback: string): string {
  return HUB_HOSTED_DOMAINS.includes(hostname) ? hostname : fallback;
}
